import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台特色</h2>
          <p className="text-sm text-foreground-500 mt-2">为什么 800 万读者选择甜柚漫画？</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 rounded-lg text-center cursor-pointer transition-all duration-300 border"
              style={{
                backgroundColor: 'oklch(var(--background-50))',
                borderColor: 'oklch(var(--background-200))',
              }}
            >
              <div
                className="w-14 h-14 mx-auto mb-4 rounded-xl flex items-center justify-center transition-colors duration-300 group-hover:opacity-90"
                style={{ backgroundColor: 'oklch(var(--primary-100))' }}
              >
                <i className={`${feature.icon} text-2xl`} style={{ color: 'oklch(var(--primary-500))' }}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}